import { takeEvery } from 'redux-saga/effects'

import {
    handleSignout,
    handleSignIn,
    handleSignUp,
    handleHardReset,
} from './session_saga.js'

import {
    handleSocketStatus,
    handleSocketEvent,
} from './socket_sagas'

import {
    handleFetchTimeEntries,
    handleFetchRunningTimeEntries,
    handleCreateTimeEntry,
    handleUpdateTimeEntry,
    handleDeleteTimeEntry,
    downloadCsv,
    pushReportToZapier,
} from './time_entries_sagas'

import {
    handleCreateTag,
    handleUpdateTag,
    handleDeleteTag,
    handleArchiveTag,
} from './tag_sagas'

import {
    queryTagReports,
} from './tag_report_sagas'

import {
    handleRangeChange,
    handleHorizonChange,
    fetchCurrentHorizon,
    selectTeamDashboardId,
} from './viewport_sagas'

import {
    handleFetchTags,
    getRecentTagCombos,
    getRecentTags,
} from './tag_sagas'

import {
    handleFetchGoals,
    refreshGoalsFromTimeEntry,
    fetchGoalForCurrentRange,
} from './goal_sagas'

import {
    handleGetProfile,
    handleChangePassword,
    handleForgotPassword,
    handleUpdateUserName,
    handleUpdateUserTimezone,
    handleVerifyEmail,
    handleUpdateNotificationPreferences,
} from './profile_sagas'

import {
    getTeamMembers,
    deleteInvite,
    createInvite,
    createTeam,
    handleDisableMember,
    handleAddMember,
    updateTeam,
    handleAcceptTeamInvite,
    handleSendBulkInvites,
    handleUpdateMemberRole,
} from './team_sagas'

import {
    handleAlert,
} from './alert_sagas'

import {
    handleSendStripeToken,
    handleCancelPlan,
    handleChangePaymentMethod,
} from './payment_sagas'

import {
    startGoogleAuth,
} from './oauth'

import {
    handleFetchTeamAccountCustomer,
    handleWebsocketCustomerUpdated,
    handleWebsocketAccountsUpdated,
} from './customer_sagas'

import {
    handleNavigateAndFetchAccountCustomer,
    handleNavigateAndPatch,
} from './ui_sagas'

import {
    handleUpdateAccountName,
    handleResendVerificationCode,
} from './account_sagas'
import { handleBootstrap } from './bootstrap_sagas.js'

// importing the action consts from action_creators does not work
// on app start they are undefined, so we use raw strings

export function *sagas() {
    return [
        // alerts
        yield takeEvery('SET_ALERTS', handleAlert),
    
        // bootstrap
        yield takeEvery('START_BOOTSTRAP', handleBootstrap),
    
        // sockets
        yield takeEvery('SOCKET_STATUS_CHANGE', handleSocketStatus),
        yield takeEvery('RECEIVE_SOCKET_EVENT', handleSocketEvent),
    
        // time entries
        yield takeEvery('FETCH_TIME_ENTRIES', handleFetchTimeEntries),
        yield takeEvery('FETCH_RUNNING_TIME_ENTRIES', handleFetchRunningTimeEntries),
        yield takeEvery('CREATE_TIME_ENTRY', handleCreateTimeEntry),
        yield takeEvery('UPDATE_TIME_ENTRY', handleUpdateTimeEntry),
        yield takeEvery('DELETE_TIME_ENTRY', handleDeleteTimeEntry),
        yield takeEvery('DOWNLOAD_CSV', downloadCsv),
        yield takeEvery('PUSH_REPORT_TO_ZAPIER', pushReportToZapier),
    
        // tags
        yield takeEvery('FETCH_TAGS', handleFetchTags),
        yield takeEvery('CREATE_TAG', handleCreateTag),
        yield takeEvery('DELETE_TAG', handleDeleteTag),
        yield takeEvery('UPDATE_TAG', handleUpdateTag),
        yield takeEvery('ARCHIVE_TAG', handleArchiveTag),
        yield takeEvery('GET_RECENT_TAG_COMBOS', getRecentTagCombos),
        yield takeEvery('GET_RECENT_TAGS', getRecentTags),
    
        // tag reports
        yield takeEvery('QUERY_TAG_REPORTS', queryTagReports),
    
        // goals
        yield takeEvery('FETCH_GOALS', handleFetchGoals),
        yield takeEvery('FETCH_GOAL', fetchGoalForCurrentRange),
        yield takeEvery('RECEIVE_TIME_ENTRY', refreshGoalsFromTimeEntry),
        yield takeEvery('REMOVE_TIME_ENTRY', refreshGoalsFromTimeEntry),
    
        // viewport
        yield takeEvery('SET_DASHBOARD_RANGE', handleRangeChange),
        yield takeEvery('SET_DASHBOARD_HORIZON', handleHorizonChange),
        yield takeEvery('FETCH_CURRENT_HORIZON', fetchCurrentHorizon),
        yield takeEvery('SELECT_TEAM_DASHBOARD', selectTeamDashboardId),
    
        // profile
        yield takeEvery('GET_PROFILE', handleGetProfile),
        yield takeEvery('CHANGE_PASSWORD', handleChangePassword),
        yield takeEvery('FORGOT_PASSWORD', handleForgotPassword),
        yield takeEvery('UPDATE_USER_NAME', handleUpdateUserName),
        yield takeEvery('UPDATE_USER_TIMEZONE', handleUpdateUserTimezone),
        yield takeEvery("VERIFY_EMAIL", handleVerifyEmail),
        yield takeEvery("UPDATE_NOTIFICATION_PREFERENCES", handleUpdateNotificationPreferences),
    
        // session
        yield takeEvery('SIGNOUT', handleSignout),
        yield takeEvery('SIGNIN', handleSignIn),
        yield takeEvery('SIGNUP', handleSignUp),
        yield takeEvery('HARD_RESET',handleHardReset),
    
        // teams
        yield takeEvery('SELECT_TEAM_DASHBOARD', getTeamMembers),
        yield takeEvery('SEND_BULK_INVITES', handleSendBulkInvites),
        yield takeEvery('HANDLE_DISABLE_MEMBER', handleDisableMember),
        yield takeEvery('HANDLE_ADD_MEMBER', handleAddMember),
        yield takeEvery('DELETE_INVITE', deleteInvite),
        yield takeEvery('CREATE_INVITE', createInvite),
        yield takeEvery('CREATE_TEAM', createTeam),
        yield takeEvery('UPDATE_TEAM', updateTeam),
        yield takeEvery('ACCEPT_TEAM_INVITE', handleAcceptTeamInvite),
        yield takeEvery('UPDATE_MEMBER_ROLE', handleUpdateMemberRole),
    
        // oauth
        takeEvery('START_GOOGLE_AUTH', startGoogleAuth),

        // payment
        yield takeEvery('HANDLE_STRIPE_TOKEN', handleSendStripeToken),
        yield takeEvery('HANDLE_CANCEL_PLAN', handleCancelPlan),
        yield takeEvery('HANDLE_CHANGE_PAYMENT_METHOD', handleChangePaymentMethod),
    
        // customer
        yield takeEvery('FETCH_TEAM_ACCOUNT_CUSTOMER', handleFetchTeamAccountCustomer),
        yield takeEvery('HANDLE_WEBSOCKET_CUSTOMER_UPDATED', handleWebsocketCustomerUpdated),
        yield takeEvery('HANDLE_WEBSOCKET_ACCOUNTS_UPDATED', handleWebsocketAccountsUpdated),
    
        // account
        yield takeEvery("UPDATE_ACCOUNT_NAME", handleUpdateAccountName),
        yield takeEvery("RESEND_VERIFICATION_CODE", handleResendVerificationCode),
    
        // ui
        yield takeEvery('HANDLE_NAVIGATE_AND_FETCH_ACCOUNT_CUSTOMER', handleNavigateAndFetchAccountCustomer),
        yield takeEvery('HANDLE_NAVIGATE_AND_PATCH', handleNavigateAndPatch),
    ]
}


// WEBPACK FOOTER //
// ./src/redux/sagas/root_saga.js